import { mapActions, mapGetters, mapState } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import loaderMixin from '@/mixins/loader';
import plusMinusSign from '@/components/generics/plus-minus-sign/plus-minus-sign.vue';
import marketEmptyState from '@/components/market/market-empty-state/market-empty-state.vue';
import { dateToString, roundToTwo, isMarketSingle } from '@/utils/helpers';
import marketContractInfoV2, { MARKET_CONTRACT_INFO_VALUES_LAYOUT } from '@/components/market/v2/market-contract-info-v2/market-contract-info-v2.vue';
import { MODALS } from '@/components/app/app-modals/modals-constants';

const MAX_CONTRACTS_NUM = 10;


export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    type: {
      type: String,
      default: 'standalone',
    },
  },
  components: {
    marketChangePrice,
    plusMinusSign,
    marketContractInfoV2,
    marketEmptyState,
  },
  data() {
    return {
      isMarketSingle,
      MARKET_CONTRACT_INFO_VALUES_LAYOUT,
      MAX_CONTRACTS_NUM,
      dateToString,
      ready: false,
    };
  },
  computed: {
    ...mapState('market', ['market', 'history', 'reloadHistoryToggle']),
    ...mapGetters('market', ['historyData']),
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    classModifiers() {
      return {
        'trade-history-sushi': true,
        [`trade-history-sushi--${this.type}`]: this.type,
      };
    },
    historyContracts() {
      return this.historyData.slice(0, MAX_CONTRACTS_NUM);
    },
  },
  watch: {
    market: {
      handler: 'marketHandler',
    },
    reloadHistoryToggle() {
      this.reloadHistory();
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('market', ['getMarketHistory', 'resetHistory']),
    showNetPLInfo() {
      this.setCurrentSmallPopup(MODALS.SMALL_TRADE_INFO);
    },
    reformatStringValue(val) {
      if (val.includes('(')) {
        return val.replace('($', '-$').replace(')', '');
      }
      return val;
    },
    itemMainDate(item) {
      const v = dateToString(item.dateExecuted).split(' ');
      return v[0];
    },
    itemSecondaryDate(item) {
      const v = dateToString(item.dateExecuted).split(' ');
      return v.slice(1, v.length).join(' ');
    },
    itemPriceInCents(item) {
      return roundToTwo(item.pricePerShare * 100);
    },
    tradeActionToString(item) {
      const type = item.tradeType;
      return (type === 0 || type === 2) ? 'NO' : 'YES';
    },
    typeToString(item) {
      switch (item.tradeType) {
        case 0: // Buy No
        case 1: // Buy Yes
          return 'Bought';
        case 2: // Sell No
        case 3: // Sell Yes
          return 'Sold';
        default:
          return 'Closed'; // 4 - Closed
      }
    },
    contractName(item) {
      if (item.marketType !== 0) {
        return item.contractName;
      }
      const type = item.tradeType;
      return (type === 0 || type === 2) ? 'NO' : 'YES';
    },
    marketHandler(value) {
      if (value) {
        this.loaderAdd();
        this.getMarketHistory({ marketId: this.market.marketId, reload: true })
          .then(() => {
            this.ready = true;
            this.loaderRemove();
          })
          .catch(() => {
            this.ready = true;
            this.loaderRemove();
          });
      }
    },
    reloadHistory() {
      this.loaderAdd();
      this.getMarketHistory({ marketId: this.market.marketId, reload: true })
        .then(() => {
          this.ready = true;
          this.loaderRemove();
        })
        .catch(() => {
          this.ready = true;
          this.loaderRemove();
        });
    },
    imageStyleModifiers(item) {
      return {
        'background-image': `url('${item.contractImageSmallUrl}')`,
      };
    },
  },
  mounted() {
    this.marketHandler(this.market);
  },
  // beforeDestroy() {
  //   this.resetHistory();
  // },
};



// WEBPACK FOOTER //
// ./src/components/trade-history-sushi/trade-history-sushi.js